import { Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { LinkOptions } from '@tanstack/react-router';
import Page from 'components/Page';
import { base, lg } from 'layouts/dashboard/MainLayout';
import { m } from 'motion/react';
import type { FC } from 'react';
import MotionContainer from './animate/MotionContainer';
import { varBounce } from './animate/variants/bounce';
import NavButton from './buttons/NavButton';

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: `calc(100vh - ${base.paddingTop + base.paddingBottom}px)`,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.up('lg')]: {
    minHeight: `calc(100vh - ${lg.paddingTop + lg.paddingBottom}px)`,
  },
}));

interface Props {
  title: string;
  subtitle?: string;
  buttonOptions?: LinkOptions & { children: string; onClick?: () => void };
}

export const ErrorPageContainer: FC<Props> = ({ title, subtitle, buttonOptions }) => (
  <Page title={title}>
    <Container component={MotionContainer}>
      <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
        <m.div variants={varBounce().in}>
          <Typography variant="h3" paragraph>
            {title}
          </Typography>
        </m.div>
        {subtitle && (
          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>{subtitle}</Typography>
          </m.div>
        )}
        {buttonOptions && <NavButton variant="contained" sx={{ mt: 3 }} {...buttonOptions} />}
      </ContentStyle>
    </Container>
  </Page>
);
